import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { isCarIcon, CarIconBadge } from '@carrent/ui'
import { api } from '@carrent/api'
import { PageHeader } from '@carrent/ui'

function CarCard({ car, onClick }) {
  return (
    <div className="card" style={{ cursor: 'pointer', padding: 0, overflow: 'hidden' }}
      onClick={onClick}>
      {/* Фото */}
      <div style={{ height: 160, background: 'var(--bg)', position: 'relative' }}>
        {car.photo_main
          ? <img src={car.photo_main} alt={`${car.brand} ${car.model}`}
              style={{ width:'100%', height:'100%', objectFit:'cover' }}
              onError={e => { e.currentTarget.style.display='none'; e.currentTarget.nextSibling.style.display='flex' }} />
          : null}
        <div style={{ width:'100%', height:'100%', display: car.photo_main ? 'none' : 'flex',
            flexDirection:'column', alignItems:'center', justifyContent:'center',
            gap:8, background:'var(--bg-card)' }}>
          <span style={{ fontSize:'3rem' }}>🚗</span>
        </div>
        {/* Госномер поверх фото */}
        <div style={{
          position:'absolute', bottom:8, left:8,
          background:'rgba(255,255,255,0.95)', color:'#000',
          padding:'3px 10px', borderRadius:6,
          fontWeight:800, fontSize:'0.82rem',
          letterSpacing:'0.08em', fontFamily:'monospace',
          border:'1px solid #444',
        }}>
          {car.plate}
        </div>
      </div>

      {/* Инфо */}
      <div style={{ padding: 'var(--gap-sm) var(--gap)' }}>
        <p style={{ fontWeight:700, fontSize:'1.05rem' }}>{car.brand} {car.model}</p>
        <div style={{ display:'flex', gap:'var(--gap-sm)', marginTop:4, flexWrap:'wrap' }}>
          {[
            car.year       && `📅 ${car.year}`,
            car.color      && `🎨 ${car.color}`,
            car.mileage    && `🛣 ${car.mileage.toLocaleString()} км`,
          ].filter(Boolean).map((item, i) => (
            <span key={i} className="text-muted" style={{ fontSize:'0.82rem' }}>{item}</span>
          ))}
        </div>

        <button className="btn btn--primary btn--full" style={{ marginTop:'var(--gap-sm)', height:44 }}>
          Выбрать эту машину →
        </button>
      </div>
    </div>
  )
}

export default function CarsPage() {
  const [cars, setCars]     = useState([])
  const [loading, setLoading] = useState(true)
  const [err, setErr]       = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    api.get('/cars/available')
      .then(r => setCars(r.data?.data || []))
      .catch(e => setErr(e.response?.data?.message || 'Не удалось загрузить список машин'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <PageHeader title="Доступные машины" />
      <div className="p-page flex-col" style={{ gap: 'var(--gap)' }}>
        {loading && (
          <div style={{ display:'flex', justifyContent:'center', padding:'3rem' }}>
            <div className="spinner" style={{ width:40, height:40 }} />
          </div>
        )}

        {err && <div className="alert alert--error">{err}</div>}

        {!loading && !err && cars.length === 0 && (
          <div style={{ textAlign:'center', padding:'3rem 0' }}>
            <div style={{ fontSize:'3rem', marginBottom:12 }}>😔</div>
            <p style={{ fontWeight:600 }}>Нет доступных машин</p>
            <p className="text-muted" style={{ fontSize:'0.88rem', marginTop:6 }}>
              Все автомобили заняты. Попробуйте позже.
            </p>
          </div>
        )}

        {!loading && cars.map(car => (
          <CarCard key={car.id} car={car}
            onClick={() => navigate('/', { state: { startTrip: car } })} />
        ))}
      </div>
    </div>
  )
}
